import { RouteConfig, Route } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import {
  authFormTemplatePermissions as Permissions,
} from '@/helpers/enums/permission-models'
import * as TYPES from '@/helpers/enums/view-types'
import { FORM_TEMPLATE_ROUTES as ROUTES } from './utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_FORM_TEMPLATE } from './utils'


const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'form-templates',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "form-template.store" */
        './store'
      )
      registerModule(options)
      const { registerModule: handbookRegisterModule } = await import(
        /* webpackChunkName: "form-handbook.store" */
        '@/views/FormsHandbook/store/cache'
      )
      handbookRegisterModule(options)
      next()
    },
    component: {
      name: 'view-form-template-layout',
      render: (h) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: Permissions.read,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "form-template.list" */
          './FormTemplatesList.vue'
        ),
      },
      {
        path: ':id(\\d+)',
        name: ROUTES.VIEW,
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.VIEW }),
        meta: {
          permission: Permissions.read,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "Form-template.view" */
          './FormTemplatesView.vue'
        ),
      },
      {
        path: ':id(\\d+)/edit',
        name: ROUTES.EDIT,
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.EDIT }),
        meta: {
          permission: Permissions.edit,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "form-template.view" */
          './FormTemplatesView.vue'
        ),
      },
      {
        path: 'create',
        name: ROUTES.CREATE,
        props: () => ({ viewType: TYPES.CREATE }),
        meta: {
          permission: Permissions.create,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "form-template.view" */
          './FormTemplatesView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options): RouteConfig[] => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
